<template>
  <input type="checkbox" :checked="checked" @change="e => $emit('change', e)" />
</template>

<script>
export default {
  name: "LinearCheckBox",
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
input {
  appearance: none;
  background-color: var(--interaction-light);
  border-radius: 72px;
  border-style: none;
  flex-shrink: 0;
  height: 24px;
  margin: 0;
  position: relative;
  width: 48px;
}

input::before {
  bottom: -6px;
  content: "";
  left: -6px;
  position: absolute;
  right: -6px;
  top: -6px;
}

input,
input::after {
  transition: all 100ms ease-out;
}

input::after {
  background-color: #fff;
  border-radius: 50%;
  content: "";
  height: 18px;
  left: 3px;
  position: absolute;
  top: 3px;
  width: 18px;
}

input[type="checkbox"] {
  cursor: default;
}

input:checked {
  background: -webkit-linear-gradient(
    -134deg,
    var(--landingfade-dark) 0%,
    var(--landingfade-light2) 100%
  );
}

input:checked::after {
  background-color: #fff;
  left: 26px;
}
</style>
